<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<nav id="sidebar" class="page-sidebar">
  <div id="sidebar-collapse">
    <ul class="side-menu metismenu">
      <li routerLinkActive="active">
        <a routerLink="/home" routerLinkActive="active">
          <em class="sidebar-item-icon ti-view-grid"></em>
          <span class="nav-label" i18n="@@home">Home</span></a>
      </li>

      <li class="heading" i18n="@@removal">Removal</li>

      <li routerLinkActive="active">
        <a routerLink="/removal" routerLinkActive="active">
          <em class="sidebar-item-icon ti-reload"></em>
          <span class="nav-label" i18n="@@removal">Removal</span></a>
      </li>

      <li routerLinkActive="active">
        <a routerLink="/history" routerLinkActive="active">
          <em class="sidebar-item-icon ti-agenda"></em>
          <span class="nav-label" i18n="@@history">History</span></a>
      </li>

      <li class="heading" i18n="@@parameters">Parameters</li>

      <li routerLinkActive="active">
        <a routerLink="/removal-points" routerLinkActive="active">
          <em class="sidebar-item-icon ti-map"></em>
          <span class="nav-label" i18n="@@myRemovalPoints">My removal points</span></a>
      </li>

      <li routerLinkActive="active">
        <a routerLink="/profile" routerLinkActive="active">
          <em class="sidebar-item-icon ti-user"></em>
          <span class="nav-label" i18n="@@myAccount">My account</span></a>
      </li>

      <li class="heading" i18n="@@informations">Informations</li>

      <li routerLinkActive="active">
        <a routerLink="/help" target="_blank" routerLinkActive="active">
          <em class="sidebar-item-icon ti-help"></em>
          <span class="nav-label" i18n="@@help">Help</span></a>
      </li>
    </ul>

    <div class="sidebar-footer">
      <a (click)="authService?.logout()" routerLinkActive="active">
        <em class="sidebar-item-icon ti-power-off text-white-50"></em>
      </a>
    </div>
  </div>
</nav>
